import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const go = (path: string) => navigate(path);

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="display">Willa Toskania</div>
          <p>Kamienny dom wśród gajów oliwnych i cyprysów, otwarty wyłącznie dla przyjaciół. Toskania, Włochy.</p>
        </div>
        <div>
          <h4>Strony</h4>
          <a onClick={() => go('/')}>Strona główna</a>
          <a onClick={() => go('/location')}>Region</a>
          <a onClick={() => go('/bedrooms')}>Sypialnie</a>
          <a onClick={() => go('/calendar')}>Kalendarium</a>
          <a onClick={() => go('/availability')}>Dostępność</a>
          <a onClick={() => go('/gallery')}>Galeria</a>
        </div>
        <div>
          <h4>Kontakt</h4>
          <a onClick={() => go('/contact')}>Napisz do nas</a>
          <a onClick={() => go('/availability')}>Sprawdź dostępność</a>
        </div>
        <div>
          <h4>Dojazd</h4>
          <a>Florencja — 50 min</a>
          <a>Piza — 30 min</a>
          <a>Lukka — 30 min</a>
          <a>Plaże — 35 min</a>
        </div>
      </div>
      <div className="footer-bottom">
        <div>© 2026 Willa Toskania — dla przyjaciół</div>
        <div>Toskania · Italia</div>
      </div>
    </footer>
  );
};

export default Footer;
